(ns ycweb.app.pos.collections.collections
  (:require
   #?@(:cljs
       [[cljs-time.format :as format]
        [cljs-time.coerce :as coerce]]
       :clj
       [[clj-time.format :as format]
        [clj-time.coerce :as coerce]])
   [rum.core :as rum]
   [ycweb.components.forms :as forms]
   [ycweb.components.buttons :as buttons]
   [ycweb.util.core :as u]
   [ycweb.components.grid :as grid]
   [ycweb.components.slats :as slats]
   [ycweb.components.wrapper :as w]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [util.string :as str]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.flow :as flow]
   [ycweb.util.comms :as comms]
   [ycweb.app.pos.sell :as sell]
   [ycweb.components.transitions :as t]))

(def steps
  (forms/setup-steps
    [{:key :scan :title "Scan Code"}
     {:key :search :title "Select Order"}
     {:key :order :title "Collect Order"}
     {:key :finished :title "Collected"}]))

(defmethod comms/receive :collection/print [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (toaster/open-toast app-atom :success "Printed" {})
  (let [printing-copy (get-in @app-atom [:collection :printing-copy])]
    (swap! app-atom
      (fn [state]
        (cond-> state
          true
          (assoc-in [:collection :complete-order :printed] true)

          (= printing-copy :merchant)
          (assoc-in [:collection :merchant-printed] true)

          (= printing-copy :customer)
          (assoc-in [:collection :customer-printed] true)

          true
          (update :collection dissoc :printing-copy))))))

(defmethod flow/barcode-dispatch-screen :collections/finished [_ app-atom scan]
  (let [collection (get-in @app-atom [:collection :complete-order])]
    (toaster/open-subtle-progress app-atom)
    (comms/send :collection/print
      (sell/sell-comms app-atom
        {:collection {:id (:deliveryid collection)} :printer scan}))))

(rum/defc collections-screen-finished < rum/reactive [app-atom]
  (let [order-atom (rum/cursor-in app-atom [:collection :complete-order])
        collection-date (cmn/curact order-atom :collection-date)
        printed? (cmn/curact order-atom :printed)
        signed? (cmn/curact order-atom :signed)
        can-device-print? (u/has-device-printer?)]
    (w/wrapper app-atom "Order Collection" {:steps steps :step :finished}
      [[:div {:class (u/bem :section [:medium])}
        [:h2.u-text-center {:class (u/bem :heading [:standard])}
         "Order Collected"]
        [:i.u-block-center {:class (u/bem :icon [:block :enormous (if (cmn/curact order-atom :printed) :success :emoticon-happy) :3-3])}]
        [:div.u-margin-top-24
         [:p.u-text-center {:class (u/bem :paragraph [:large])}
          [:b "Collected by: " (cmn/curact order-atom :receiver-firstname) " " (cmn/curact order-atom :receiver-lastname)]
          [:span.u-hidden-from-view " "]
          (when collection-date
            [:span.u-block "on "
             (format/unparse (format/formatter "E, do MMMM YYYY h:mma")
               (coerce/from-date collection-date))])]]
        [:div.u-margin-top-24
         (feedback/action-feedback :pencil "Slip has been signed" "" (rum/cursor-in order-atom [:signed]) {})]]]

      [(when-not printed?
         [:div
          [:p.paragraph.paragraph--flush.u-text-center
           "Scan printer to print slip"]
          (when (and (not signed?) (u/has-device-printer?) can-device-print?)
            [:p.paragraph.paragraph--flush.u-text-center
             "Or use the device's printer"])])]

      (grid/pos-call-to-action
        {:single-text
         (cond
           (and (not signed?) (u/has-device-printer?) can-device-print?)
           "Use Device Printer"

           :else
           "Done")
         :single-fn
         (cond
           (and (not signed?) (u/has-device-printer?) can-device-print?)
           #(t/transition-next app-atom :collections/device-print)

           signed?
           (fn []
             (swap! app-atom dissoc :collection)
             (t/transition-next app-atom :main-menu)))}))))

(defmethod flow/render-screen :collections/finished [app-atom screen]
  (collections-screen-finished app-atom))

(defn collection-device-print [app-atom {:keys [merchant]}]
  (let [collection (get-in @app-atom [:collection :complete-order])]
    (swap! app-atom assoc-in [:collection :printing-copy] (if merchant :merchant :customer))
    (toaster/open-subtle-progress app-atom)
    (comms/send :collection/print
      (sell/sell-comms app-atom
        {:collection {:id (:deliveryid collection)}
         :printer "DEVICE-PRINTER"
         :merchant merchant}))))

(rum/defc collections-device-print-screen < rum/reactive [app-atom]
  (let [order-atom (rum/cursor-in app-atom [:collection :complete-order])
        collection-atom (rum/cursor-in app-atom [:collection])
        merchant-printed (cmn/curact collection-atom :merchant-printed)
        customer-printed (cmn/curact collection-atom :customer-printed)
        done-enabled? customer-printed]
    (w/wrapper app-atom "Order Collection" {:steps steps :step :finished}
      [[:div {:class (u/bem :section [:medium])}
        [:h2.u-text-center {:class (u/bem :heading [:large])}
         [:b "Print Slips"]]
        [:p.u-text-center {:class (u/bem :paragraph [:flush])}
         "Print customer copy to continue"]

        [:div.u-margin-top-24
         (when merchant-printed
           (feedback/feedback :success "Merchant Copy" "Printed"))
         [:div.u-margin-top-16.u-text-center
          (buttons/button
            (if merchant-printed "Reprint Merchant Copy" "Print Merchant Copy")
            #(collection-device-print app-atom {:merchant true})
            {:icon-right :print :raised true :large true
             :primary (not merchant-printed) :secondary merchant-printed})]]

        [:div.u-margin-top-24
         (when customer-printed
           (feedback/feedback :success "Customer Copy" "Printed"))
         [:div.u-margin-top-16.u-text-center
          (buttons/button
            (if customer-printed "Reprint Customer Copy" "Print Customer Copy")
            #(collection-device-print app-atom {:merchant false})
            {:icon-right :print :raised true :large true
             :primary (not customer-printed) :secondary customer-printed})]]

        [:div.u-margin-top-24
         (feedback/action-feedback :pencil "Slip has been signed" "" (rum/cursor-in order-atom [:signed]) {})]]]

      []
      (grid/pos-call-to-action
        {:single-text "Done"
         :single-fn
         (when (and done-enabled? (cmn/curact order-atom :signed))
           (fn []
             (swap! app-atom dissoc :collection)
             (t/transition-next app-atom :main-menu)))
         :single-style :call-to-action}))))

(defmethod flow/render-screen :collections/device-print [app-atom screen]
  (collections-device-print-screen app-atom))

(defmethod flow/barcode-dispatch-screen :collections/device-print [_ app-atom scan]
  (toaster/open-toast app-atom :warning "Use the print buttons on screen" {}))

(defmethod comms/receive :collection/submit [app-atom e]
  (swap! app-atom
    (fn [state]
      (-> state
        (assoc :collection
          {:complete-order
           (assoc (get-in state [:collection :order]) :collection-date (:date e))}))))
  (t/transition-next app-atom :collections/finished)
  (toaster/open-toast app-atom :success "Collection captured." {}))

(defmethod grid/action :collections/capture-collection [app-atom config _]
  (let [collection (get-in @app-atom [:collection :order])]
    (comms/send :collection/submit
      (sell/sell-comms app-atom
        {:collection {:id (:deliveryid collection)}
         :name (str (:receiver-firstname collection) " " (:receiver-lastname collection))}))
    (toaster/open-toast app-atom :processing "Processing collection" {})))

(rum/defc collections-screen-customer < rum/reactive [app-atom]
  (let [order-atom (rum/cursor-in app-atom [:collection :order])
        details-completed
        (and
          (u/presence (cmn/curact order-atom :receiver-firstname))
          (u/presence (cmn/curact order-atom :receiver-lastname)))]
    (w/wrapper app-atom "Order Collection" {:steps steps :step :order}
      [[:div {:class (u/bem :section [:medium])}

        [:h2.u-text-center {:class (u/bem :heading [:standard])}
         (str "Collection Order: " (cmn/curact order-atom :ref))
         [:span.u-hidden-from-view " "]
         [:span.u-block.u-text-normal
          (str "for " (cmn/curact order-atom :firstname) " " (cmn/curact order-atom :lastname))]]

        [:p.form-question "Collected by:"]
        (forms/split-input-field
          ["First Name:" "e.g. Jane" (rum/cursor order-atom :receiver-firstname) {:type :user}]
          ["Last Name:" "e.g. Smith" (rum/cursor order-atom :receiver-lastname) {:type :user}])

        [:div.u-margin-top-24.u-text-right
         (buttons/button "Copy Customer"
           #(swap! order-atom
              (fn [s]
                (assoc s
                  :receiver-firstname (:firstname s)
                  :receiver-lastname (:lastname s))))
           {:icon-left :copy-content :muted true :text-default true})]]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Collect"
         :right-style :call-to-action
         :right-no-icon true
         :right-fn
         (when details-completed
           #(grid/dispatch-action app-atom :collections/capture-collection {}))}))))

(defmethod flow/render-screen :collections/customer [app-atom screen]
  (collections-screen-customer app-atom))

(defmethod flow/barcode-dispatch-screen :collections/order [_ app-atom scan]
  (let [box
        (->>
          (get-in @app-atom [:collection :order :boxes])
          (map-indexed #(assoc %2 :idx %1))
          (filter #(= (:barcode %) scan))
          first)]
    (if box
      (swap! app-atom assoc-in [:collection :order :boxes (:idx box) :selected] true)
      (toaster/open-toast app-atom :error "Box not found on order." {:closetime 2000}))))

(defmethod comms/receive :collection/print-run [app-atom e]
  ;; TODO: This shouldn't be here. Needs removing.
  ;; But it means that we need to actually rework the locality of 'send-message' to have a notion
  ;; of 'blocking'
  (grid/close-modal app-atom))

(defmethod flow/barcode-dispatch-modal :collection/print-slip [_ app-atom scan]
  (let [state @app-atom
        collection (get-in state [:collection :order])
        firstname (get-in state [:collection :lookup :firstname])
        lastname (get-in state [:collection :lookup :lastname])]

    (comms/send :collection/print-run
      (sell/sell-comms app-atom
        {:customer (when firstname (str firstname " " lastname))
         :boxes (:boxes collection)
         :order-ref (:ref collection)
         :scan scan}))))

(rum/defc collection-print-slip-modal-body [app-atom config-atom]
  [[:h3
    {:class (u/bem :heading [:medium-large])}
    "Print Runner Slip"]
   [:div.form-field
    (feedback/feedback
      :barcode-scan "Scan printer to print slip"
      "Box locations will be printed on the slip" nil :info :smaller)]])

(defmethod grid/action :collection/device-print-slip [app-atom config _]
  (let [state @app-atom
        collection (get-in state [:collection :order])
        firstname (get-in state [:collection :lookup :firstname])
        lastname (get-in state [:collection :lookup :lastname])]
    (comms/send :collection/print-run
      (sell/sell-comms app-atom
        {:customer (when firstname (str firstname " " lastname))
         :boxes (:boxes collection)
         :order-ref (:ref collection)
         :scan "DEVICE-PRINTER"}))))

(rum/defc collection-print-slip-modal-footer < rum/reactive [app-atom]
  (if (u/has-device-printer?)
    (grid/button-row
      {:left-text "Cancel"
       :left-style :secondary
       :left-fn #(grid/dispatch-modal-action app-atom :stock/stock-item-modal-cancel)
       :right-text "Device Printer"
       :right-style :call-to-action
       :right-fn #(grid/dispatch-modal-action app-atom :collection/device-print-slip)})
    (grid/button-row
      {:single-text "Cancel"
       :single-style :secondary
       :single-fn #(grid/dispatch-modal-action app-atom :stock/stock-item-modal-cancel)})))

(defmethod grid/modal-config :collection/print-slip [_ _ _]
  {:body collection-print-slip-modal-body
   :footer collection-print-slip-modal-footer
   :modal-type :alert})

(defn collection-printslip [app-atom]
  (grid/open-modal app-atom :collection/print-slip {}))

(defn get-selected-boxes [items]
  (vec (filter #(= (:selected %) true) items)))

(rum/defc collections-screen-order < rum/reactive [app-atom]
  (let [order-atom (rum/cursor-in app-atom [:collection :order])
        boxes (cmn/curact order-atom :boxes)
        boxes-collected (= (count boxes) (count (get-selected-boxes (cmn/curact order-atom :boxes))))]
    (w/wrapper app-atom "Order Collection" {:steps steps :step :order}
      [[:div {:class (u/bem :section [:medium])}

        [:h2.u-text-center {:class (u/bem :heading [:standard])}
         (str "Collection Order: " (cmn/curact order-atom :ref))
         [:span.u-hidden-from-view " "]
         [:span.u-block.u-text-normal
          (str "for " (cmn/curact order-atom :firstname) " " (cmn/curact order-atom :lastname))]]
        (->>
          boxes
          (map-indexed
            (fn [idx i]
              {:sort-key (str (:location i) " " (:barcode i))
               :component
               (feedback/action-feedback :location (str (:location i) ": ")
                 (:barcode i) (rum/cursor-in order-atom [:boxes idx :selected])
                 {})}))
          (sort-by :sort-key)
          (map :component))
        [:div.u-margin-top-24.u-text-right
         (buttons/button "Runner Slip"
           #(collection-printslip app-atom)
           {:icon-left :download :muted true :text-default true})]]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Next"
         :right-fn
         (when boxes-collected
           #(t/transition-next app-atom :collections/customer))}))))

(defmethod flow/render-screen :collections/order [app-atom screen]
  (collections-screen-order app-atom))

(rum/defc collections-screen-search < rum/reactive [app-atom]
  (let [collection-atom (rum/cursor-in app-atom [:collection])]
    (w/wrapper app-atom "Order Collection" {:steps steps :step :search}
      [[:div {:class (u/bem :section [:medium])}
        [:h2.u-text-center {:class (u/bem :heading [:standard])}
         "Search results for"
         [:span.u-hidden-from-view " "]
         [:span.u-block (cmn/curact collection-atom [:user :email])]]]
       (map
         (fn [o]
           (slats/collection-order-slat o
             {:on-click
              #(do
                 (t/transition-next app-atom :collections/order)
                 (swap! app-atom assoc-in [:collection :order] o))}))
         (cmn/curact collection-atom :orders))]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod flow/render-screen :collections/search [app-atom screen]
  (collections-screen-search app-atom))

(defmethod comms/receive :collection/lookup [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (if (= (get-in @app-atom [:collection :name]) (:lookup e))
    (swap! app-atom assoc-in [:collection :lookup]
      (update e :orders #(map (fn [o] (update o :boxes vec)) %)))))

(defn collections-lookup [app-atom]
  (swap! app-atom update :collection dissoc :lookup)
  (toaster/open-subtle-progress app-atom)
  (comms/send :collection/lookup
    (sell/sell-comms app-atom
      {:lookup (get-in @app-atom [:collection :name])})))

(defonce collection-lifecycle-listener
  (cmn/lifecycle-listener :collection/setup :setup
    (fn [app-atom]
      (cmn/debounce-in app-atom [:collection :name]
        500
        #(when (and (>= (count %) 2))
           (collections-lookup app-atom))))))

(defmethod flow/barcode-dispatch-screen :collections [_ app-atom scan]
  (let [scan
        (if (str/starts-with? (str/lower-case scan) "http://")
          (str "YC" (re-find #"[0-9]+" scan)) scan)]
    (swap! app-atom assoc :collection {:name scan})
    (toaster/open-subtle-progress app-atom)))

(rum/defc collections-screen-start < rum/reactive [app-atom]
  (let [collection-atom (rum/cursor-in app-atom [:collection])
        lookup (cmn/curact collection-atom :lookup)
        {:keys [found correct-warehouse? orders]} lookup
        chosen (if (= found :customer) (first orders) lookup)
        warehouse-name (:warehouse_name chosen)
        order-count (count (cmn/curact collection-atom [:lookup :orders]))]
    (w/wrapper app-atom "Order Collection" {:steps steps :step :scan}
      [[:div.u-margin-top-24
        [:div {:class (u/bem :section [:medium])}
         [:h2.u-text-center {:class (u/bem :heading [:standard])}
          "Scan Order Collection QR Code"
          [:span.u-hidden-from-view " "]
          [:span.heading__subtext "or enter manually in the field below"]]
         (forms/input "" "e.g. YC123456789" (rum/cursor collection-atom :name)
           {:hint "e.g. YC123456789 or jane.smith@domain.com"
            :type :barcode})]
        [:div
         {:class (u/bem :section [:standard])}
         (when (cmn/curact collection-atom :lookup)
           (case found
             :customer
             (cond
               (and (> order-count 0) correct-warehouse?)
               (feedback/feedback
                 :success "User Found"
                 (str "Press Next to view collections linked to " (cmn/curact collection-atom [:lookup :email])))

               (> order-count 0)
               (feedback/feedback
                 :warning "User Found"
                 (str "But collection linked to Warehouse: " warehouse-name))

               :else
               (feedback/feedback
                 :error "No collections found"
                 "This user has no orders ready for collection"))

             :order
             (cond
               (and (= :ready-for-collection (:status lookup)) correct-warehouse?)
               (feedback/feedback
                 :success "Order Found"
                 (str "Press Next to view the items for order " (cmn/curact collection-atom [:lookup :ref])))

               (= :ready-for-collection (:status lookup))
               (feedback/feedback
                 :warning "Order Found in Warehouse: " warehouse-name)

               :else
               (feedback/feedback
                 :error "Order not ready"
                 "This order is not ready for collection yet."))

             (feedback/feedback
               :error "No order or user found"
               "Please enter the complete order number or complete email address")))]]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom :main-menu)
         :right-text "Next"
         :right-fn
         (case
           (and
             (or
               (and (= found :customer) (> order-count 0))
               (and (= found :order) (= :ready-for-collection (:status lookup))))
             correct-warehouse?
             found)

           :customer
           (when (> order-count 0)
             #(do
                (t/transition-next app-atom :collections/search)
                (swap! app-atom update :collection :lookup)))
           :order
           #(do
              (t/transition-next app-atom :collections/order)
              (swap! app-atom update :collection (fn [c] (assoc c :order (:lookup c)))))
           nil)}))))

(defmethod flow/render-screen :collections [app-atom screen]
  (collections-screen-start app-atom))